/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleDeviceIssuesResponse } from './equipment-schedule-device-issues-response';
import { EquipmentScheduleChangeStatuses } from './equipment-schedule-change-statuses';


export interface UpdateEquipmentCalendarScheduleResponse { 
    status?: EquipmentScheduleChangeStatuses;
    conflicts?: Array<EquipmentScheduleDeviceIssuesResponse> | null;
}



